<template>
  <div class="privacy-policy">
    <div class="title">摩征隐私政策</div>
    <h2>引言</h2>
    <div class="section">
      <p>宗申•比亚乔佛山摩托车企业有限公司（以下称“我们”或“摩征”）非常重视用户（以下简称“您”）的隐私和个人信息保护。</p>
      <p>摩征视用户信息安全与隐私保护为自己的“生命线”。我们秉承“一切以用户价值为依归”的理念，致力于提升信息处理透明度，增强您对信息管理的便捷性，保障您的信息及通信安全。</p>
      <p>摩征严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：</p>
      <ul class="ul">
        <li>
          <strong class="num">1、</strong>
          <p><strong>安全可靠：</strong>我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失。</p>
        </li>
        <li>
          <strong class="num">2、</strong>
          <p><strong>自主选择：</strong>我们为您提供便利的信息管理选项，以便您做出合适的选择，管理您的个人信息。</p>
        </li>
        <li>
          <strong class="num">3、</strong>
          <p><strong>保护通信秘密：</strong>我们严格遵照法律法规，保护您的通信秘密，为您提供安全的通信服务。</p>
        </li>
        <li>
          <strong class="num">4、</strong>
          <p><strong>合理必要：</strong>为了向您和其他用户提供更好的服务，我们仅收集必要的信息。</p>
        </li>
        <li>
          <strong class="num">5、</strong>
          <p><strong>清晰透明：</strong>我们努力使用简明易懂的表述，向您介绍隐私政策，以便您清晰地了解我们的信息处理方式。</p>
        </li>
        <li>
          <strong class="num">6、</strong>
          <p><strong>将隐私保护融入产品设计：</strong>我们在产品或服务开发的各个环节，综合法律、产品、设计等多方因素，融入隐私保护的理念。</p>
        </li>
      </ul>
      <p>本《隐私政策》主要向您说明：</p>
      <ul class="ul">
        <li><p><strong>我们收集哪些信息；</strong></p></li>
        <li><p><strong>我们收集信息的用途；</strong></p></li>
        <li><p><strong>您所享有的权利。</strong></p></li>
      </ul>
      <p>希望您仔细阅读《隐私政策》（以下简称“本政策”），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。</p>
      <p><strong>若您使用摩征服务，即表示您认同我们在本政策中所述内容。</strong>除另有约定外，本政策所用术语与<a href="https://production.motorjourney.cn/h5#/userAgreement">《摩征注册服务协议》</a>中的术语具有相同的涵义。</p>
      <p>如您有问题，请联系我们。</p>
    </div>
    <!-- 一 -->
    <h2>一、我们收集的信息</h2>
    <div class="section">
      <p>我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。</p>
      <ul class="ul">
        <p><strong>1.1 您在使用我们服务时主动提供的信息</strong></p>
        <ul class="ul">
          <li><strong>1.1.1 您在注册帐户时填写的信息。</strong><p class="example">例如，您在注册摩征帐户时所填写的昵称、手机号码。</p></li>
          <li><strong>1.1.2 您在使用服务时上传的信息。</strong><p class="example">例如，您在使用摩征时，上传的头像、分享的照片。</p></li>
          <li><strong>1.1.3 您通过我们的客服或参加我们举办的活动时所提交的信息。</strong><p class="example">例如，您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、家庭地址等信息。</p></li>
        </ul>
      </ul>
      <p>我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。<strong>若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。</strong></p>
      <ul class="ul">
        <p><strong>1.2 我们在您使用服务时获取的信息</strong></p>
        <ul class="ul">
          <li>
            <strong>1.2.1 日志信息。</strong>当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。
            <p class="level-3"><strong>(1) 设备信息。</strong>例如，设备型号、操作系统版本、唯一设备标识符、电池、信号强度等信息。</p>
            <p class="level-3"><strong>(2) 软件信息。</strong>例如，软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需，我们会收集有关您使用的移动应用和其他软件的信息。</p>
            <p class="level-3"><strong>(3) IP地址。</strong></p>
            <p class="level-3"><strong>(4) 服务日志信息。</strong>例如，您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。</p>
            <p class="level-3"><strong>(5) 通讯日志信息。</strong>例如，您在使用我们服务时曾经通讯的账户、通讯时间和时长。</p>
          </li>
          <li>
            <strong>1.2.2 位置信息。</strong>当您使用与位置有关的服务时，我们可能会记录您设备所在的位置信息，以便为您提供相关服务。
            <p class="level-3">(1) 在您使用服务时，我们可能会通过IP地址、GPS、WLAN（如 WiFi）或基站等途径获取您的地理位置信息；</p>
            <p class="level-3">(2) 您或其他用户在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的帐号信息中可能包含的您所在地区信息，您或其他人共享的照片包含的地理标记信息；</p>
          </li>
          <li>
            <strong>1.2.3 其他相关信息。</strong>为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。例如，我们收集的好友列表、群列表信息、声纹特征值信息。为确保您使用我们服务时能与您认识的人进行联系，如您选择开启导入通讯录功能，我们可能对您联系人的姓名和电话号码进行加密，并仅收集加密后的信息。
          </li>
        </ul>
      </ul>
      <ul class="ul">
        <p><strong>1.3 其他用户分享的信息中含有您的信息</strong></p>
        <li>例如，其他用户发布的照片或分享的视频中可能包含您的信息。</li>
      </ul>
    </div>
    <!-- 二 -->
    <h2>二、我们如何使用收集的信息</h2>
    <div class="section">
      <p>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</p>
      <ul class="ul">
        <li><p><strong>2.1 向您提供服务。</strong></p></li>
        <li><p><strong>2.2 满足您的个性化需求。</strong>例如，语言设定、位置设定、个性化的帮助服务。</p></li>
        <li><p><strong>2.3 产品开发和服务优化。</strong>例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。</p></li>
        <li><p><strong>2.4 安全保障。</strong>例如，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。例如，您下载或安装的安全软件会对恶意程序或病毒进行检测，或为您识别诈骗信息。</p></li>
        <!-- <li><p><strong>2.5 向您推荐您可能感兴趣的广告、资讯等。</strong></p></li> -->
        <li><p><strong>2.5 评估、改善我们的广告投放和其他促销及推广活动的效果。</strong></p></li>
        <li><p><strong>2.6 管理软件。</strong>例如，进行软件认证、软件升级等。</p></li>
        <li><p><strong>2.7 邀请您参与有关我们服务的调查。</strong></p></li>
        <p>为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。</p>
        <!-- <div>例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务。</div> -->
        <p>为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。</p>
      </ul>
    </div>
    <!-- 三 -->
    <h2>三、我们如何使用Cookie及相关技术</h2>
    <div class="section">
      <p>我们或我们的第三方合作伙伴，可能通过放置安全的Cookie及相关技术收集您的信息，我们会严格要求第三方合作伙伴遵守本政策的相关规定。</p>
      <!-- <div>目的是为您提供更个性化的用户体验和服务。</div> -->
      <p>您也可以通过浏览器设置管理Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>
    </div>
    <!-- 四 -->
    <h2>四、您分享的信息</h2>
    <div class="section">
      <p>您可以通过我们的服务与您的好友、家人及其他用户分享您的相关信息。请注意，这其中可能包含您的个人身份信息、个人财产信息等敏感信息。<strong>请您谨慎考虑披露您的相关个人敏感信息。</strong></p>
      <p>您可通过我们服务中的隐私设置来控制您分享信息的范围，也可通过服务中的设置或我们提供的指引删除您公开分享的信息。<strong>但请您注意，这些信息仍可能由其他用户或不受我们控制的非关联第三方独立地保存。</strong></p>
    </div>
    <!-- 五 -->
    <h2>五、您如何管理自己的信息</h2>
    <div class="section">
      <ul class="ul">
        <li><div class="num">5.1</div><p class="pl">您可以在使用我们服务的过程中，访问、修改和删除您提供的注册信息和其他个人信息，也可按照通知指引与我们联系。<strong>您访问、修改和删除个人信息的范围和方式将取决于您使用的具体服务。</strong>例如，若您在使用地理位置相关服务时，希望停止分享您的地理位置信息，您可通过手机定位关闭功能、软硬件服务商及通讯服务提供商的关闭方式停止分享，建议您仔细阅读相关指引。</p></li>
        <li><div class="num">5.1.1</div><p class="pl" style="padding-left: 20px">删除权。您有权擦除您的个人信息。您随时可以通过本软件来擦除您的所有或部分个人信息。一旦您删除后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定。</p></li>
        <li><div class="num">5.1.2</div><p class="pl" style="padding-left: 20px">注销账号。您可以在【我的】-【设置】-【账号管理】-【永久注销账号】进行帐号注销。在您注销帐号前，我们将验证您的个人身份、安全状态、设备信息等。您知悉并理解，注销帐号的行为是不可逆的行为，当您注销帐号后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理，但法律法规另有规定的除外 。</p></li>
        <li><div class="num">5.2</div><p class="pl"><strong>我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。</strong>如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。请通过本政策列明的联系方式与我们联系。</p></li>
        <li><div class="num">5.3</div><p class="pl">在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。</p></li>
        <li><div class="num">5.4</div><p class="pl">请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。</p></li>
      </ul>
    </div>
    <!-- 六 -->
    <h2>六、我们分享的信息</h2>
    <div class="section">
      <p>我们遵照法律法规的规定，对信息的分享进行严格的限制，例如：</p>
      <ul class="ul">
        <li><div class="num">6.1</div><p class="pl">经您事先同意，我们可能与第三方分享您的个人信息；</p></li>
        <li>
          <div class="num">6.2</div>
          <p class="pl">仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、承包商、代理、广告合作伙伴、应用开发者等，例如，代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置服务的地图服务供应商）（他们可能并非位于您所在的法域）分享您的个人信息，让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，并用于以下用途：</p>
          <p class="pl">6.2.1 向您提供我们的服务；</p>
          <p class="pl">6.2.2 实现“我们如何使用收集的信息”部分所述目的；</p>
          <p class="pl">6.2.3 履行我们在<a href="https://production.motorjourney.cn/h5#/userAgreement">《摩征注册服务协议》</a>或本政策中的义务和行使我们的权利；</p>
          <p class="pl">6.2.4 理解、维护和改善我们的服务。</p>
          <p class="pl">如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全。</p>
        </li>
        <li><div class="num">6.3</div><p class="pl">随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本政策所要求的标准继续保护或要求新的管理者继续保护您的个人信息。</p></li>
        <li><div class="num">6.4</div><p class="pl">我们会将所收集到的信息用于大数据分析。例如，我们将收集到的信息用于分析形成不包含任何个人信息的城市热力图或行业洞察报告。我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解用户如何使用我们服务或让公众了解我们服务的总体使用趋势。</p></li>
        <li>
          <div class="num">6.5</div>
          <p class="pl">我们可能基于以下目的披露您的个人信息：</p>
          <p class="pl">6.5.1 遵守适用的法律法规等有关规定；</p>
          <p class="pl">6.5.2 遵守法院判决、裁定或其他法律程序的规定；</p>
          <p class="pl">6.5.3 遵守相关政府机关或其他法定授权组织的要求；</p>
          <p class="pl">6.5.4 我们有理由确信需要遵守法律法规等有关规定；</p>
          <p class="pl">6.5.5 为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。</p>
          <p class="pl">6.5.6</p>
          <p class="pl">为保障摩征服务的相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）或类似应用程序实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）或类似应用程序进行严格的安全评估，以保护您的个人信息安全。我们将会根据本隐私政策的约定与我们合作的第三方共享您的个人信息，但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的合作方如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
        </li>
      </ul>
      <div class="content">
        <table class="table-style" border="0" cellspacing="0">
          <thead>
            <tr>
              <th width="120">第三方SDK名称</th>
              <th width="120">第三方名称</th>
              <th width="100">使用目的</th>
              <th width="100">使用场景</th>
              <th width="150">收集个人信息</th>
              <th width="100">收集方式</th>
              <th>隐私权政策链接</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>友盟SDK</td>
              <td>友盟同欣(北京)科技有限公司</td>
              <td>用户使用效果统计</td>
              <td>用户点击、分享内容时</td>
              <td>IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置</td>
              <td>SDK本机采集</td>
              <td>https://www.umeng.com/policy</td>
            </tr>
            <tr>
              <td>微信SDK</td>
              <td>深圳市腾讯计算机系统有限公司</td>
              <td>分享到微信、支付、登录</td>
              <td>使用微信登录及支付、分享至微信时</td>
              <td>系统语言，外部存储状态，最近一次地理位置信息，网络位置信息，持续定位，网络类型，手机号码，SIM 卡序列号，网络服务运营商，IMEI，MAC 地址，ANDROID_ID，IP 地址，WiFi 信息，应用安装列表，读取剪切板</td>
              <td>SDK本机采集</td>
              <td>https://privacy.qq.com/</td>
            </tr>
            <tr>
              <td>环信即时通讯SDK</td>
              <td>北京易掌云峰科技有限公司</td>
              <td>社交</td>
              <td>用户使用私信或车队内聊天时</td>
              <td>相机，网络类型，网络服务运营商，IMEI，MAC 地址，ANDROID_ID，IP 地址，WiFi 信息，相册</td>
              <td>SDK本机采集</td>
              <td>https://www.easemob.com/protocol</td>
            </tr>
            <tr>
              <td>高德地图SDK</td>
              <td>高德软件有限公司</td>
              <td>位置展示、地图导航</td>
              <td>用户查看所在附近经销商、车辆位置时</td>
              <td>Wifi信息、位置信息、IMSI、ssid、任务列表、设备版本、MAC地址、bssid、IMEI、手机样式、经度、纬度、网络设备制造商、android_id</td>
              <td>SDK本机采集</td>
              <td>https://lbs.amap.com/home/privacy/</td>
            </tr>
            <tr>
              <td>七牛云SDK</td>
              <td>上海七牛信息技术有限公司</td>
              <td>用于用户上传图片到动态图片/用户个人头像等。</td>
              <td>用于用户修改个人头像或发布动态上传图片视频时</td>
              <td>厂商、机型、系统版本、网络类型（例如 Wi-FI、3G、4G）</td>
              <td>SDK本机采集</td>
              <td>https://www.qiniu.com/en/privacy-right</td>
            </tr>
            <tr>
              <td>OPPO推送</td>
              <td>OPPO广东移动通信有限公司</td>
              <td>消息推送</td>
              <td>消息推送</td>
              <td>IMEI、OAID、硬件序列号、IMSI、Android ID、IP、Google Advertising ID 、BSSID、手机区域设置、设备型号、设备型号、手机电量、手机操作系统版本及语言、网络类型、运营商信息、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）</td>
              <td>SDK本机采集</td>
              <td>https://open.oppomobile.com/wiki/doc#id=10288</td>
            </tr>
            <tr>
              <td>小米推送</td>
              <td>小米科技有限责任公司</td>
              <td>消息推送</td>
              <td>消息推送</td>
              <td>设备型号、设备厂商、网络类型、设备归属地（国家或地区）、SIM卡运营商名称、设备内存、操作系统版本、小米推送SDK版本、IMEI、硬件序列号、SSID、IMEI、Android ID、OAID、运行进程、VAID、AAID、MID（适用于MIUI系统）、设备存储空间、SDK版本、手机区域设置、通知栏状态、锁屏状态、应用信息（包名、版本号、应用名称、首次安装时间、上次完成更新的时间、运行状态）、IDFV（仅限IOS）、消息创建、送达和点击时间、从第三方应用处获得并推送给您的消息内容、通知栏设置信息，包括是否屏蔽通知栏、是否设置锁屏弹出消息</td>
              <td>SDK本机采集</td>
              <td>https://dev.mi.com/console/doc/detail?pId=1822</td>
            </tr>
            <tr>
              <td>Vivo推送</td>
              <td>广东步步高电子工业有限公司</td>
              <td>消息推送</td>
              <td>消息推送</td>
              <td>Android ID、OAID/VAID/AAID、IMSI、BSSID、IMEI、操作系统版本号、无线网络列表、设备MAC地址、ICCID 、EMMCID/UFSID 、网络类型、设备型号、硬件序列号、SSID、位置信息、移动国家码、运营商信息、使用语言、系统设置、设备和应用程序数据</td>
              <td>SDK本机采集</td>
              <td>https://dev.vivo.com.cn/documentCenter/doc/366</td>
            </tr>
            <tr>
              <td>华为HMS推送</td>
              <td>华为技术有限公司</td>
              <td>消息推送</td>
              <td>消息推送</td>
              <td>应用基本信息（AppID，推送服务和HMS Core应用版本号）、应用内标识符（AAID和Push Token）、设备类型、系统类型（如Android，HarmonyOS等）、系统版本、BSSID、IMEI、无线网络列表、网络类型、网络状态、设备型号、SSID、AAID、手机ID、应用包名、服务器公网IP地址、国家码、位置信息</td>
              <td>SDK本机采集</td>
              <td>https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</td>
            </tr>
            <tr>
              <td>魅族推送</td>
              <td>魅族科技有限公司</td>
              <td>消息推送</td>
              <td>消息推送</td>
              <td>BSSID、无线网络列表、设备MAC地址、网络类型、设备型号、硬件序列号、SSID、位置信息、运行任务、Android ID、运营商信息</td>
              <td>SDK本机采集</td>
              <td>https://www.meizu.com/legal.html</td>
            </tr>
            <tr>
              <td>新浪微博分享</td>
              <td>北京微梦创科网络技术有限公司</td>
              <td>分享</td>
              <td>分享</td>
              <td>IMSI、IMEI、设备MAC地址、Android ID、SSID、BSSID、设备制造商、硬件序列号、设备型号、OPENUDID、GUID、OAID、SIM卡序列号、分享的资源（如图片、视频、酒店/旅游资源）、位置信息、IP、IDFA（仅限IOS）、IDFV（仅限IOS）、设备名称（仅限IOS）、已安装应用包名、运营商信息</td>
              <td>SDK本机采集</td>
              <td>https://open.weibo.com/wiki/Sdk/privacy</td>
            </tr>
            <tr>
              <td>微信分享&登录&支付</td>
              <td>腾讯科技（深圳）有限公司</td>
              <td>分享&登录&支付</td>
              <td>分享&登录&支付</td>
              <td>设备MAC地址、IMEI、SIM卡序列号、Android ID、设备型号、SSID、BSSID、硬件序列号、IDFA（仅限IOS）、分享的资源（如第三方应用中主动选择的图片或内容、酒店/旅游资源）、微信头像、昵称信息、微信支付订单标识、位置信息、已安装应用包名、剪贴板</td>
              <td>SDK本机采集</td>
              <td>https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</td>
            </tr>
            <tr>
              <td>QQ钱包</td>
              <td>财付通支付科技有限公司</td>
              <td>第三方支付</td>
              <td>第三方支付</td>
              <td>支付受理终端信息、唯一设备识别码（如设备的MAC、IMEI等能识别设备的标识信息）、硬件设备型号、终端系统类型、软件安装信息、使用的软件版本信息、软件语言设置信息、互联网协议地址（IP地址）、移动网络信息（如Wi-Fi信息）、所在的地区、网络日志和网络使用习惯以及您使用财付通服务的操作行为记录</td>
              <td>SDK本机采集</td>
              <td>https://privacy.qq.com/document/preview/4796a8f96429482293dd15bc17b92c65</td>
            </tr>
            <tr>
              <td>银联支付</td>
              <td>上海银联商务有限公司</td>
              <td>第三方支付</td>
              <td>第三方支付</td>
              <td>IMEI、IMSI、设备MAC地址、手机号、位置信息、设备型号、IDFA（仅限IOS）、IP地址</td>
              <td>SDK本机采集</td>
              <td>https://open.unionpay.com/tjweb/doc/index</td>
            </tr>
            <tr>
              <td>百度地图&定位</td>
              <td>北京百度在线网络技术有限公司</td>
              <td>位置及定位等地图服务</td>
              <td>位置及定位等地图服务</td>
              <td>Android ID、系统信息（操作系统版本、设备品牌及型号、设备配置）、应用信息（应用名）、网络类型、传感器信息、制造商、设备名称、无线网络列表、BSSID、SSID、SIM卡状态、IDFA（仅限IOS）、IDFV（仅限IOS）、蓝牙信息、WIFI信息、IP、位置信息、SD卡目录</td>
              <td>SDK本机采集</td>
              <td>https://lbs.baidu.com/index.php?title=openprivacy</td>
            </tr>
            <tr>
              <td>中国电信统一认证</td>
              <td>世纪龙信息网络有限责任公司</td>
              <td>一键登陆功能</td>
              <td>登陆功能</td>
              <td>设备信息（可能包括IP、Android ID、SIM卡序列号、SIM卡状态、IMEI、IMSI、网络类型、无线网络设备IP、BSSID、设备型号、运行进程信息、设备名称、系统版本、 IDFA（仅限IOS））、手机号</td>
              <td>SDK本机采集</td>
              <td>https://e.189.cn/legalStatement.jsp</td>
            </tr>
            <tr>
              <td>中国移动统一认证</td>
              <td>世纪龙信息网络有限责任公司</td>
              <td>一键登陆功能</td>
              <td>登陆功能</td>
              <td>设备信息（可能包括IP、Android ID、SIM卡序列号、SIM卡状态、IMEI、IMSI、网络类型、无线网络设备IP、BSSID、设备型号、运行进程信息、设备名称、系统版本、 IDFA（仅限IOS））、手机号、运营商信息</td>
              <td>SDK本机采集</td>
              <td>http://dev.10086.cn/</td>
            </tr>
            <tr>
              <td>OAID</td>
              <td>中国信息通信研究院</td>
              <td>实现设备的匿名标识，降低被广告追踪的可能性</td>
              <td>实现设备的匿名标识，降低被广告追踪的可能性</td>
              <td>网络状态、通话状态、OAID、AAID、VAID、设备制造商、运营商信息</td>
              <td>SDK本机采集</td>
              <td>http://msa-alliance.cn/col.jsp?id=120</td>
            </tr>
            <tr>
              <td>Facebook React Native</td>
              <td>Facebook Inc.</td>
              <td>提升APP开发效率</td>
              <td>提升APP开发效率</td>
              <td>IMEI、IMSI、Android ID、BSSID、SSID、位置信息、剪切板、网络状态、设备型号、设备品牌、硬件序列号、传感器信息、传感器列表、IDFA（仅限IOS）、设备MAC地址、应用是否安装、IP、SD卡目录、wifi信息</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>友盟</td>
              <td>同欣（北京）科技有限公司</td>
              <td>统计&推送</td>
              <td>统计&推送</td>
              <td>运行进程信息 设备信息（可能包括手机型号/无线MAC地址/网络连接信息/SSID/BSSID/MAC地址/IMEI/无线网络状态/Android ID/IDFA/OpenUDID/GUID/SIM卡 IMSI/IP/传感器信息/通话状态/地理位置/oaid/SIM卡序列号）和基站定位信息、SD卡目录、android_id</td>
              <td>SDK本机采集</td>
              <td>https://www.umeng.com/page/policy</td>
            </tr>
            <tr>
              <td>UC啄木鸟</td>
              <td>广州市动景计算机科技有限公司</td>
              <td>生成崩溃日志</td>
              <td>生成崩溃日志</td>
              <td>外部文件存储目录信息、设备MAC地址、设备型号</td>
              <td>SDK本机采集</td>
              <td>http://open-uc.uc.cn/agreement/secret</td>
            </tr>
            <tr>
              <td>NineOldAndroids动画库</td>
              <td>无，开源工具</td>
              <td>开源工具</td>
              <td>开源工具</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>Apache</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>开发工具</td>
              <td>设备信息（包含ip地址）</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>GSON</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>开发工具</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>Zxing二维码扫描</td>
              <td>无，开源工具</td>
              <td>二维码扫描</td>
              <td>二维码扫描时</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>okhttp</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>网络请求时</td>
              <td> 运行进程信息、ip</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>chromium</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>通过内置浏览器访问时</td>
              <td>无线网络信息（SSID、WIFI状态）、传感器信息、传感器列表、设备MAC地址、IP、剪切板、通话状态</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>阿里UTDID</td>
              <td>支付宝（中国）网络技术有限公司</td>
              <td>生成唯一性ID</td>
              <td>生成唯一性ID</td>
              <td>IMSI、IMEI、Android ID、访问外部存储卡、运行进程、网络类型、MAC地址</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>智行</td>
              <td>上海蒜芽信息科技有限公司</td>
              <td>基础平台</td>
              <td>基础平台</td>
              <td>剪切板、android_id、IP、运行进程信息、SSID、应用列表、传感器列表</td>
              <td>SDK本机采集</td>
              <td>https://pages.ctrip.com/ztrip/document/privacypolicyzx.html?noticetype=1&appid=1003</td>
            </tr>
            <tr>
              <td>Glide</td>
              <td>Glide</td>
              <td>图片加载和缓存功能</td>
              <td>图片加载和缓存功能</td>
              <td>读取、写入设备外置储存卡、ip</td>
              <td>SDK本机采集</td>
              <td>https://github.com/bumptech/glide</td>
            </tr>
            <tr>
              <td>Alipay</td>
              <td>支付宝网络有限公司</td>
              <td>第三方支付</td>
              <td>选择、进行第三方支付时</td>
              <td>设备型号、品牌、设备型号、制造商、设备MAC地址、IMSI、BSSID、WIFI状态/参数/列表、传感器信息、传感器列表、IMEI、Android ID、ICCID、网络类型、运营商信息、硬件序列号、SIM卡序列号、IDFA（仅限IOS）、IDFV（仅限IOS）、SSID、IP、运行任务、已安装应用包名、系统设置、系统属性、蓝牙地址、oaid、SD卡目录、运行进程、位置信息</td>
              <td>SDK本机采集</td>
              <td>https://opendocs.alipay.com/open/54</td>
            </tr>
            <tr>
              <td>fastjson</td>
              <td>阿里巴巴(中国)有限公司（已开源）</td>
              <td>开源JSON解析库</td>
              <td>开源JSON解析库</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/alibaba/fastjson</td>
            </tr>
            <tr>
              <td>smack</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>开发工具</td>
              <td>IP地址</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>okio</td>
              <td>无，开源工具</td>
              <td>方便开发过程中请求服务端数据，简化开发步骤，提升开发效率</td>
              <td>方便开发过程中请求服务端数据，简化开发步骤，提升开发效率</td>
              <td>设备标识符（包括Android ID、IMEI、MAC）、设备类型、设备型号、IP</td>
              <td>SDK本机采集</td>
              <td>https://github.com/square/okio/</td>
            </tr>
            <tr>
              <td>LeakCanary</td>
              <td>Square公司</td>
              <td>内存泄漏检测</td>
              <td>APP运行过程</td>
              <td>当前运行进程、访问外部存储卡</td>
              <td>SDK本机采集</td>
              <td>https://square.github.io/leakcanary/</td>
            </tr>
            <tr>
              <td>QQ登录&分享（QQ互联）</td>
              <td>腾讯科技（深圳）有限公司</td>
              <td>登录&分享</td>
              <td>通过QQ账号登陆或分享到QQ</td>
              <td>设备MAC地址、IMEI、SIM卡序列号、Android ID、操作系统、设备型号、应用安装列表、分享的资源（如酒店、旅游资源）、IDFA（仅限IOS）、位置信息、IP、已安装应用包名、剪切板信息（App使用分享能力并拉起手机QQ，仅限IOS）、相册/内存卡权限、应用列表信息、SD卡目录</td>
              <td>SDK本机采集</td>
              <td>https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e</td>
            </tr>
            <tr>
              <td>okhttp</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>网络请求时</td>
              <td>IP、当前运行进程</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>腾讯Mmkv SDK</td>
              <td>腾讯</td>
              <td>开发工具</td>
              <td>开发工具</td>
              <td>oaid、传感器列表、传感器信息</td>
              <td>SDK本机采集</td>
              <td>https://mvnrepository.com/artifact/com.tencent/mmkv?repo=jcenter</td>
            </tr>
            <tr>
              <td>美团Robust热更新</td>
              <td>北京三快在线科技有限公司（已开源）</td>
              <td>快速修复APP线上问题</td>
              <td>快速修复APP线上问题</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/Meituan-Dianping/Robust</td>
            </tr>
            <tr>
              <td>greenrobot EventBus</td>
              <td>无，开源工具</td>
              <td>提升通讯质量</td>
              <td>提升通讯质量</td>
              <td>网络类型</td>
              <td>SDK本机采集</td>
              <td>https://github.com/greenrobot/EventBus</td>
            </tr>
            <tr>
              <td>GreenDAO</td>
              <td>无，开源工具</td>
              <td>开源的安卓ORM</td>
              <td>开源的安卓ORM</td>
              <td>网络类型</td>
              <td>SDK本机采集</td>
              <td>http://greenrobot.org/greendao</td>
            </tr>
            <tr>
              <td>ARouter</td>
              <td>阿里巴巴</td>
              <td>协助Android组件化改造的路由框架</td>
              <td>协助Android组件化改造的路由框架</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/alibaba/ARouter</td>
            </tr>
            <tr>
              <td>GSON</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>开发工具</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>Godeye</td>
              <td>无，开源工具</td>
              <td>内存泄漏检测</td>
              <td>内存泄漏检测</td>
              <td>运行进程</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>flutter</td>
              <td>Google</td>
              <td>框架类</td>
              <td>框架类</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/flutter/flutter</td>
            </tr>
            <tr>
              <td>Facebook Fresco AnimatedGif</td>
              <td>Facebook</td>
              <td>基本功能类</td>
              <td>基本功能类</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://mvnrepository.com/artifact/com.facebook.fresco/animated-gif</td>
            </tr>
            <tr>
              <td>trove</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>开发工具</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>JetBrains Java Annotations</td>
              <td>无，开源工具</td>
              <td>用于编写应用基础组件</td>
              <td>用于编写应用基础组件</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/JetBrains/java-annotations</td>
            </tr>
            <tr>
              <td>lenovo-opendeviceid SDK</td>
              <td> 联想集团有限公司</td>
              <td>用于实现跨厂商的统一设备标识（OAID）</td>
              <td>用于实现跨厂商的统一设备标识（OAID）</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>http://open.lenovomm.com/developer/footer/foot_protection.jsp#protection_a_2</td>
            </tr>
            <tr>
              <td>zip4j</td>
              <td>无，开源工具</td>
              <td>开发工具</td>
              <td>开发工具</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>iqiyi xCrash</td>
              <td>北京爱奇艺科技有限公司（已开源）</td>
              <td>提供捕获 java 崩溃，native 崩溃和 ANR 的能力</td>
              <td>提供捕获 java 崩溃，native 崩溃和 ANR 的能力</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/iqiyi/xCrash</td>
            </tr>
            <tr>
              <td>XRecyclerView</td>
              <td>无，开源工具</td>
              <td>页面渲染</td>
              <td>页面渲染</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/XRecyclerView/XRecyclerView</td>
            </tr>
            <tr>
              <td>PhotoView</td>
              <td>无，开源工具</td>
              <td>实现图片展示功能</td>
              <td>实现图片展示功能</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/chrisbanes/PhotoView</td>
            </tr>
            <tr>
              <td>Facebook Fresco AnimatedWebp</td>
              <td>Facebook Inc.</td>
              <td>支持动画webp的类</td>
              <td>支持动画webp的类</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://mvnrepository.com/artifact/com.facebook.fresco/animated-webp</td>
            </tr>
            <tr>
              <td>Facebook Fresco</td>
              <td>Facebook Inc.</td>
              <td>图像加载和显示</td>
              <td>图像加载和显示</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/facebook/fresco</td>
            </tr>
            <tr>
              <td>Android Support RecyclerView</td>
              <td> Android Jetpack 社区</td>
              <td>基本功能类</td>
              <td>在您的界面中显示大量数据，同时最大限度减少内存用量。</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://mvnrepository.com/artifact/androidx.recyclerview/recyclerview</td>
            </tr>
            <tr>
              <td>anet.channel.strategy</td>
              <td>提高推送效率</td>
              <td>Crash监控</td>
              <td>Crash监控</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td></td>
            </tr>
            <tr>
              <td>Walle（瓦力）</td>
              <td>美团</td>
              <td>打包工具</td>
              <td>打包工具</td>
              <td>无</td>
              <td>SDK本机采集</td>
              <td>https://github.com/Meituan-Dianping/walle</td>
            </tr>
            <tr>
              <td>个推消息推送SDK</td>
              <td>每日互动股份有限公司</td>
              <td>为App用户提供消息推送技术服务</td>
              <td>为App用户提供消息推送技术服务</td>
              <td>设备识别码（IMEI、IDFA（仅限IOS）、Android ID、Mac地址、OAID、Advertising ID、Serial Number、IMSI、UAID、ICCID）、IP地址、wifi信息、基站信息、sd卡目录、SSID、BSSID、位置信息、应用安装列表、 设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）</td>
              <td>SDK本机采集</td>
              <td>https://docs.getui.com/privacy/</td>
            </tr>
            <tr>
              <td>Matrix</td>
              <td>深圳市腾讯计算机系统有限公司 （已开源）</td>
              <td>性能监控</td>
              <td>性能监控</td>
              <td>运行进程</td>
              <td>SDK本机采集</td>
              <td>https://github.com/tencent/matrix;https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/yTezupX6yF028Mpf</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 七 -->
    <h2>七、我们可能向您发送的信息</h2>
    <div class="section">
      <ul class="ul">
        <li><div class="num">7.1</div><p class="pl">信息推送</p><p>您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。</p></li>
        <li><div class="num">7.2</div><p class="pl">与服务有关的公告</p><p>我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。</p></li>
      </ul>
    </div>
    <h2>八、存储信息的地点和期限</h2>
    <div class="section">
      <ul class="ul">
        <li><div class="num">8.1</div><p class="pl">存储信息的地点</p><p>我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。</p></li>
        <li>
          <div class="num">8.2</div>
          <p class="pl">存储信息的期限</p>
          <p>一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
          <p>8.2.1 为遵守适用的法律法规等有关规定；</p>
          <p>8.2.2 为遵守法院判决、裁定或其他法律程序的规定；</p>
          <p>8.2.3 为遵守相关政府机关或法定授权组织的要求；</p>
          <p>8.2.4 我们有理由确信需要遵守法律法规等有关规定；</p>
          <p>8.2.5 为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</p>
          <p>当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。</p>
        </li>
      </ul>
    </div>
    <!-- 九 -->
    <h2>九、信息安全</h2>
    <div class="section">
      <p>我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。</p>
      <ul class="ul">
        <li><div class="num">9.1</div><p class="pl">我们严格遵守法律法规保护用户的通信秘密。</p></li>
        <li><div class="num">9.2</div><p class="pl">我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全、保护用户信息。例如，我们使用加密技术（例如，TLS、SSL）、匿名化处理等手段来保护您的个人信息。</p></li>
        <li><div class="num">9.3</div><p class="pl">我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。</p></li>
        <li><div class="num">9.4</div><p class="pl">若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。</p></li>
      </ul>
    </div>
    <!-- 十 -->
    <h2>十、广告</h2>
    <div class="section">
      <p>我们可能使用您的相关信息，在相关网站、应用及其他渠道向您提供与您更加相关的广告。</p>
    </div>
    <!-- 十一 -->
    <h2>十一、未成年人保护</h2>
    <div class="section">
      <p>我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用摩征的服务前，应事先取得您的家长或法定监护人的同意。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第十三部分中的联系方式与我们联系。未成年人使用我们的产品与服务需在父母或监护人的监护与同意下进行。我们不会收集未成年人的个人信息,除非事先征得父母或监护人的明确同意。父母和监护人应当指导和监督未成年人使用我们的服务。</p>
    </div>
    <!-- 十二 -->
    <h2>十二、适用范围</h2>
    <div class="section">
      <p>我们的所有服务均适用本政策。但某些服务有其特定的隐私指引/声明，该特定隐私指引/声明更具体地说明我们在该服务中如何处理您的信息。如本政策与特定服务的隐私指引/声明有不一致之处，请以该特定隐私指引/声明为准。</p>
      <p>请您注意，本政策不适用由其他公司或个人提供的服务。</p>
      <p>您使用该等第三方服务须受其隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。</p>
    </div>
    <!-- 十三 -->
    <h2>十三、联系我们</h2>
    <div class="section">
      <p>如您对本政策或其他相关事宜有疑问，请拨打0757-82304728与我们联系。您也可将您的问题发送至liujinlong@piaggio.com.cn或寄到如下地址：</p>
      <p>地址：中国广东省佛山市禅城区张槎街道 宗申•比亚乔佛山摩托车企业有限公司（收）</p>
      <p>邮编：528051</p>
      <p>我们将尽快审核所涉问题，并在验证您的用户身份后的十五天内予以回复。</p>
    </div>
    <!-- 十四 -->
    <h2>十四、变更</h2>
    <div class="section">
      <p>我们可能适时修订本政策内容。如该等变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。<strong>在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。</strong></p>
      <p>更新日期：2023年5月30日</p>
      <p>生效日期：2023年5月30日</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  components: {},
  props: {},
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="less">
.privacy-policy{
  max-width: 900px;
  margin: 0 auto;
  .title{
    color: #000;
    font-size: 22px;
    font-weight: bold;
    padding-left: 10px;
    padding-top: 16px;
  }
  .section{
    font-size: 16px;
    padding: 0 10px;
    .ul{
       li{
        position: relative;
        padding-left: 20px;
       }
      .num{
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .pl{
      padding-left: 10px;
    }
    .level-3{
      padding-left: 20px;
      margin-top: 5px;
      margin-bottom: 8px;
    }
    .example{
      margin-top: 5px;
      margin-bottom: 8px;
    }
  }
  h2{
    position: relative;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    height: 28px;
    color: #0052d9;
    text-indent: 8px;
    margin: 16px 0 19px 8px;
    background-color: #e2edfb;
    &::after{
      content: '';
      position: absolute;
      top: 0;
      left: -8px;
      width: 4px;
      height: 28px;
      background-color: #0052d9;
    }
  }
  .content{
    position: relative;
    width: 100%;
    overflow-x: auto;
    border: 1px solid #b8bcc7;
    border-right: none;
    border-bottom: none;
    overflow: auto;
  }
  .table-style{
    width: 1000px;
    th{
      font-size: 14px;
    }
    th, td{
      display: table-cell;
      margin: 0;
      padding: 8px;
      border-right: 1px solid #b8bcc7;
      border-bottom: 1px solid #b8bcc7;
      box-sizing: border-box;
    }
    td{
      font-size: 12px;
    }
  }
}
</style>
